import { Link } from 'react-router-dom';

const confettiPieces = Array.from({ length: 34 }, (_, index) => ({
  id: index,
  left: `${(index * 29) % 100}%`,
  delay: `${(index % 9) * 0.13}s`,
  duration: `${2.3 + (index % 5) * 0.24}s`,
  color: ['#0D9488', '#D97706', '#059669', '#0D1117', '#CBD5E1'][index % 5],
}));

export default function WelcomeScreen({ firstName }) {
  const greeting = firstName ? `, ${firstName}` : '';
  return (
    <section className="relative animate-scale-in overflow-hidden rounded-[16px] border border-slate-200 bg-white shadow-2xl shadow-slate-900/10">
      <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true">
        {confettiPieces.map((piece) => (
          <span
            key={piece.id}
            className="confetti-piece"
            style={{
              left: piece.left,
              animationDelay: piece.delay,
              animationDuration: piece.duration,
              backgroundColor: piece.color,
            }}
          />
        ))}
      </div>

      <div className="relative bg-gradient-to-br from-teal-600 via-teal-700 to-obsidian-400 px-5 py-8 text-white sm:px-8 sm:py-10">
        <p className="text-xs font-bold uppercase tracking-[0.18em] text-teal-100">You're in{greeting}</p>
        <h1 className="mt-4 font-display text-[34px] leading-[1.05] text-white sm:text-[44px]">
          Get paid for research interviews — and let AI find you a job while you wait.
        </h1>
        <p className="mt-4 max-w-lg text-base leading-7 text-white/85">
          Two streams of value, one profile. Here's what's about to happen on your dashboard.
        </p>
      </div>

      <div className="relative space-y-4 p-5 sm:p-8">
        <div className="rounded-[12px] border border-amber-200 bg-amber-50 p-5 text-amber-900">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-amber-700">Upcoming paid interviews</p>
          <p className="mt-2 font-display text-2xl leading-tight text-amber-900">
            Campaigns will appear here as they match you.
          </p>
          <p className="mt-2 text-sm text-amber-800">
            We pay $50–$300 per session. You only see the ones you're a fit for — no spam.
          </p>
        </div>

        <div className="rounded-[12px] border border-teal-200 bg-teal-50 p-5 text-teal-900">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-teal-700">Your job matches</p>
          <p className="mt-2 font-display text-2xl leading-tight text-teal-900">
            Auto-apply will queue up jobs the moment you're approved.
          </p>
          <p className="mt-2 text-sm text-teal-800">
            We tailor your resume and apply for you. You stay in the loop without doing the busywork.
          </p>
        </div>

        <Link
          to="/dashboard/jobs"
          className="mt-2 flex h-14 w-full items-center justify-center rounded-[10px] bg-teal-600 px-5 text-base font-bold text-white shadow-lg shadow-teal-900/15 transition hover:bg-teal-700 focus:outline-none focus:ring-4 focus:ring-teal-200"
        >
          Open your dashboard
        </Link>
      </div>
    </section>
  );
}
